import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { GeographiesService } from 'projects/services/src/app/API/geographies.service';
import { environment } from 'src/environments/environment';
import { distinct } from 'rxjs/operators';

@Component({
	selector: 'app-address',
	templateUrl: './address.component.html',
	styleUrls: ['./address.component.css']
})
export class AddressComponent implements OnInit {
	showErrors: boolean;
	parliaments: any[];
	mandals: any[];
	districts: any[];
	states: any;
	address: FormGroup;
	@Output() addressChange = new EventEmitter();
	constructor(
		private fb: FormBuilder,
		private geographiesService: GeographiesService,
	) {
		this.createForm();
	}

	ngOnInit() {
		this.getStates();
		this.getParliaments();
	}
	createForm() {
		this.address = this.fb.group({
			country: [{
				code: 91,
				name: 'India'
			}],
			addressLine1: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9#]+[a-zA-Z0-9# @/,&()-]*[a-zA-Z0-9]$')]],
			landmark: ['', [Validators.pattern('^[a-zA-Z]+[a-zA-Z0-9# @/,&()-]*[a-zA-Z0-9]$'), Validators.minLength(5)]],
			// tslint:disable-next-line:max-line-length
			pincode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern(new RegExp('^[1-9][0-9]{5}$'))]],
			state: ['', [Validators.required]],
			district: ['', [Validators.required]],
			mandal: ['', [Validators.required]],
			parliamentConstituency: ['', [Validators.required]]
		});
	}
	getStates() {
		this.geographiesService.getStates()
			.subscribe(states => {
				this.states = states.states;
			}, error => {
				console.log('Error in fetching states : ', error);
			});
	}
	getDistrictsInTheState() {
		this.districts = [];
		this.address.get('district').setValue(null);
		this.mandals = [];
		this.address.get('mandal').setValue(null);

		this.address.get('parliamentConstituency').setValue(null);
		this.geographiesService.getDistricts(this.address.get('state').value.code)
			.subscribe(districts => {
				this.districts = districts.districts;
			}, error => {
				console.log(`Error while fetching districts : ${error}`);
			});
	}
	getMondelInTheDistrricts() {
		this.mandals = [];
		this.address.get('mandal').setValue(null);

		this.address.get('parliamentConstituency').setValue(null);
		this.geographiesService.getTehsil(this.address.get('district').value.code)
			.subscribe((mandals) => {
				this.mandals = mandals.subDistricts;
			}, error => {
				console.log(`Error while fetching tehsils : ${error}`);
			});

	}
	getParliaments() {
		this.address.get('parliamentConstituency').setValue(null);
		this.parliaments = [{ 'code': 1, 'name': 'uthukottai' }, { 'code': 2, 'name': 'Thiruthani' }];
	}
	emitValue() {
		this.addressChange.emit(this.address.value);
	}
	showSelected(item, formControlValue): boolean {
		if (item && formControlValue) {
			return item.code === formControlValue.code;
		} else {
			return false;
		}
	}
	// checkIfValid(formControl: AbstractControl) {
	// 	if (formControl.invalid) {
	// 		return true;
	// 	} else if (formControl.invalid && formControl.dirty) {
	// 		return true;
	// 	}
	// 	return false;
	// }
}
